// extracted by mini-css-extract-plugin
export var arrowLink = "ArrowLink-module--arrowLink--1-yrr";
export var blueLink = "ArrowLink-module--blueLink--QoV57";
export var yellowLink = "ArrowLink-module--yellowLink--CqaqP";